<template>
    <div class="foroContainer">
    <div class="card" v-for="item in foros" :key="item.Id">
      <ForoCard :post="item"
        :isHome = true 
        @openPost="openPost"
      />
    </div>
  </div>
</template>

<script>
    import ForoCard from '../Cards/foroCard'

    export default {
        name: "HomeForo",
        components: { ForoCard },
        props: {
            data: { propType: Array, default: [] },
        },  
        data() {
            return {
                foros: this.data,
            }
        },
        watch: {
            data(newVal) {
                this.foros = newVal
            }
        },
        mounted () {
            //console.log(this.foros);
        },
        methods: {
            openPost(id) {
                this.$router.push({ name: "Post", params: { id: id } });
            },
        },
    }
</script>

<style scoped>
    .foroContainer > div {
        margin-bottom: 15px;
    }
    .card {
        cursor: pointer;
        /* transition: 0.2s all ease; */
    }
</style>